import { render, staticRenderFns } from "./VKPayment.vue?vue&type=template&id=872bc910&lang=pug&"
import script from "./VKPayment.vue?vue&type=script&lang=ts&"
export * from "./VKPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports